module.exports = __webpack_public_path__ + "media/src/fonts/roboto-mono/roboto-mono-300-light-italic-320351f467917d7e28b15fe830b7688b.woff2";